module.exports = __webpack_public_path__ + "static/img/shangpin3.7437ca76.png";